import React from 'react';
import Container from '../../atoms/Container';
import Styles from './BlogTexto.css';

function BlogTexto({ text, title, subtitle, h4title, children, ...props }) {
  return (
    <>
      <article {...props} className="blog-texto">
        <Container extraPadding>
          {title && (
            <h2
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          )}
          {subtitle && <h3>{subtitle}</h3>}
          {h4title && (
            <h4
              dangerouslySetInnerHTML={{
                __html: h4title,
              }}
            />
          )}
          {!!text ? (
            <p
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            />
          ) : (
            <p>{children}</p>
          )}
        </Container>
      </article>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BlogTexto;
